//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getWheelRound } from "@/api";
import UiGameInfo from './components/UiGameInfo.vue';
import WheelGameColorTabs from './components/GameColorTabs.vue';
import WheelGameColor from './components/GameColor.vue';

import { GameStatus, Multiplier, Game, WheelColor } from './wheel.entity';

export default {
    name: 'WheelGame',
    components: {
        UiGameInfo,
        WheelGameColorTabs,
        WheelGameColor
    },
    data() {
        return {
            Multiplier,
            GameStatus,
            preloadBets: new Array(10),
            // 状态管理注入或通过 Props 传入
            wheelState: {
                game: new Game,
                colorX2: new WheelColor(),
                colorX3: new WheelColor(),
                colorX4: new WheelColor(),
                colorX35: new WheelColor()
            }
        };
    },
    computed: {
        currencyType() {
            return Number(this.$route.meta?.currencyType ?? this.$route.query.currencyType ?? 0);
        },
        currencyTypeLabel() {
            if (this.currencyType === 1) return '欢乐豆';
            if (this.currencyType === 2) return '金豆';
            return '现金';
        },
        gameData() {
            return this.wheelState.game;
        }
    },
    created() {
        this.fetchRound()

    },
    beforeDestroy() {
        if (typeof this.wheelState.reset === 'function') {
            this.wheelState.reset();
        }
    },
    methods: {

        getColorKeyByMultiplier(color) {
            if (color === Multiplier.X2 || color === 'X2' || color === 0) return 'colorX2';
            if (color === Multiplier.X3 || color === 'X3' || color === 1) return 'colorX3';
            if (color === Multiplier.X4 || color === 'X4' || color === 2) return 'colorX4';
            if (color === Multiplier.X35 || color === 'X35' || color === 3) return 'colorX35';
            return null;
        },
        parseBet(betDto) {

            const targetColorKey = this.getColorKeyByMultiplier(betDto.color ?? betDto.colorId);
            if (targetColorKey && this.wheelState[targetColorKey]) {
                const colorBank = this.wheelState[targetColorKey];
                colorBank.totalBankUsd += (betDto.itemsTotal || betDto.betAmount || 0);

                const hasUserBet = colorBank.bets.some(b => b.user.id === betDto.userId);
                if (!hasUserBet) {
                    colorBank.usersCount += 1;
                }

                colorBank.bets.unshift(betDto);
            }

        },
        async fetchRound() {
            try {
                let id = this.$route.params.id;
                // console.log(1111, this.$route.params) : '6ad7ef9f-b1aa-45af-af2b-adde2dfddae9' }
                const data = await getWheelRound({ id, currencyType: this.currencyType });
                console.log("fetchRound data:", data);
                this.wheelState.game = data?.data.data.game;
                console.log(" this.wheelState.game:", this.wheelState.game);
                const allBets = data?.data.data.bets || [];
                allBets.forEach(bet => {
                    this.parseBet(bet);
                });
            } catch (error) {
                console.log("There was an error while loading crash schema:", error);
            }
        },
        setMetaTags(game) {
            const multiplier = WHEEL_MULTIPLIERS[game.winColor] || '';
            const title = `轮盘游戏 #${game.id}`;
            const description = `轮盘游戏 #${game.id} 已结束！投注 ${multiplier} 的玩家获得了胜利，赢得了总金额为 ${game.totalBankUsd} 的底池！`;

            document.title = title;

            let metaDesc = document.querySelector('meta[name="description"]');
            if (metaDesc) {
                metaDesc.setAttribute('content', description);
            } else {
                metaDesc = document.createElement('meta');
                metaDesc.name = 'description';
                metaDesc.content = description;
                document.head.appendChild(metaDesc);
            }
        }
    }
};
